module.exports = __webpack_public_path__ + "static/media/success.ac3a813c.svg";